var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showPrescriptionModule)?_c('div',{staticClass:"PrescriptionLensData"},[_c('Header'),_vm._v(" "),_c('Frame'),_vm._v(" "),_c('div',{staticClass:"Prescription"},[_c('Steps')],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }